export function scrollToAnchors() {
    $('.home .header a').on('click', function (e) {
        e.preventDefault();
        const target = $(this).attr('href');

        $('body').removeClass('menu-opened');
        $('.btn-menu').removeClass('open');
        $('html, body').animate({
            scrollTop: $(target).offset().top - $('.header').innerHeight()
        }, 1000);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollToAnchors.js